<script>
    import getSecret from '@utils/get-secret'
    import Layout from '@layouts/main'
    import PageHeader from '@components/page-header'
    import BaseDatatable from '@components/base-datatable'
    import { smartCarMethods, euroCouponsTutorialMethods } from '@state/helpers'
    import cardholderForm from '@views/timesoft/form'
    import cardholderDelete from '@components/euro_smart_car/delete'
    
    var colors = {
      hex: '#194d33',
      a: 1,
    }
    
    export default {
      page: {
        title: 'Cargue de turnos',
        meta: [{ name: 'description', content: getSecret('DESCRIPTION') }],
      },
      components: {
        UploadData: () => import('@components/timesoft/UploadData'),
        Layout, PageHeader, BaseDatatable, 
        cardholderForm, cardholderDelete },
      data() {
        return {
          title: 'Cargue de turnos',
          items: [
            {
              text: 'Inicio',
              href: '/',
            },
            {
              text: 'Cargue de turnos',
              active: true,
            },
          ],
          tableHeaders: [
            { key: 'actions', label: 'Acciones' },
          ],
          action: '',
          detailModal: {
            id: 'info-modal',
            title: '',
            content: '',
          },
          toUpdate : {},
          toDelete: {},
          showForm: false,
          showFormEdit: false,
          showFormDelete: false,
          typeAction:'create',
          showDelete: false,
          isSubmitting: false,
          actionsLoadings: {},
        }
      },
      mounted() {
        this.setShowTutorial(true)
        this.setTutorialUrl('timesoft')
      },
      destroyed() {
        this.setShowTutorial(false)
      },
      methods: {
        ...smartCarMethods,
        ...euroCouponsTutorialMethods,
        myProvider(ctx) {
          return []
          const promise = this.fetchCardholders(this.$table_params(ctx))
          return promise
            .then((data) => {
              return data
            })
            .catch((error) => {
              this.$axios_error_noty(error, this)
              console.log(error)
              return []
            })
        },
        openCreateUpdateModal(item, row) {
          let context = this
          if (item) {
            context.toUpdate = item
          } else {
            context.toUpdate = {}
          }
          context.showForm = true
          context.typeAction = 'create'
        },
        openDeleteUpdateModal(item, row) {
          let context = this
          if (item) {
            context.toUpdate = item
          } else {
            context.toUpdate = {}
          }
          context.showForm = true
          context.typeAction = 'delete'
        },
        openUpdateModal(item, row) {
          let context = this
          if (item) {
            context.toUpdate = item
          } else {
            context.toUpdate = {}
          }
          context.showFormEdit = true
          context.typeAction = 'update'
        },
        openDeleteModal(item, row) {
          let context = this
          if (item) {
            context.toDelete = item
          } else {
            context.toDelete = {}
          }
          context.showFormDelete = true
        },
      },
    }
    </script>
    <template>
      <Layout>
        <PageHeader :title="title" :items="items" />
        <b-container fluid class="p-0">
          <b-row>
            <b-col>
              <b-card class="shadow">
                <!---->
                <BaseDatatable
                  ref="table"
                  :drfprovider="myProvider"
                  :tableheaders="tableHeaders"
                > 
                  <template v-slot:buttons>
                    <b-button
                      variant="outline-primary rounded-lg shadow-sm"
                      size="sm"
                      @click="openCreateUpdateModal(null, null)"
                    >
                      <i class=" fas fa-plus"></i>
                    </b-button>
                  </template>
                </BaseDatatable>
              </b-card>
            </b-col>
          </b-row>
        </b-container>
    
        <UploadData
          v-if="showForm"
          :type_action="typeAction"
          :fullform="true"
          :instanceJson="toUpdate || {}"
          :oncomplete="
            () => {
              showForm = false
              toUpdate = {}
              $refs.table.refresh()
            }
          "
          :oncancel="
            () => {
              showForm = false
              toUpdate = {}
            }
          "
        >
        </UploadData>
    
        <cardholderForm
          v-if="showFormEdit"
          :instanceJson="toUpdate || {}"
          :oncomplete="
            () => {
              showFormEdit = false;
              toUpdate = {};
              $refs.table.refresh()
            }
          "
          :oncancel="
            () => {
              showFormEdit = false;
              toUpdate = {}
            }
          "
        >
        </cardholderForm>
    
        <cardholderDelete
          v-if="showFormDelete"
          :instanceJson="toDelete"
          :oncomplete="
            () => {
              showFormDelete = false;
              toDelete = {};
              $refs.table.refresh()
            }
          "
          :oncancel="
            () => {
              showFormDelete = false;
              toDelete = {}
            }
          "
        >
        </cardholderDelete>
      </Layout>
    </template>
    